/* eslint-disable */
import * as uiConfigModule from '@onereach/ui-config';
import config from '../env.json';
import { isExactFeature, isLocal, SSO_TEST_FEATURE } from './utils/envCheckers';
// @ts-ignore
import runningProjects from 'runningProjects';
// @ts-ignore
import localOverrides from 'localOverrides';

declare const __TEST_EXTERNAL_PROVIDERS__: (typeof import('../env.external_providers.json'))['qa'] | null;


/*
  If statement bellow is used for testing external providers inside AUTH UI module.
  Wiki: https://onereach.atlassian.net/wiki/spaces/AUTH/pages/266043393/Testing+env+setup+overview
*/

if (isExactFeature(SSO_TEST_FEATURE)) {
  const testExternalProviders = __TEST_EXTERNAL_PROVIDERS__;

  if (testExternalProviders) {
    config['PROVIDERS_ACCOUNT_ID'] = testExternalProviders.PROVIDERS_ACCOUNT_ID;
    if (!isLocal(config)) {
      config['EXTERNAL_PROVIDERS'] = testExternalProviders.EXTERNAL_PROVIDERS;
    } else {
      config['EXTERNAL_PROVIDERS'] = testExternalProviders.EXTERNAL_PROVIDERS.map(e => ({
        ...e,
        ...(e.name === 'oauth' ? { url: `${localOverrides.AUTH_UI_URL}/oauth_idp` } : null),
        redirectPath: `${localOverrides.AUTH_UI_URL}/activity`,
      }));
    }
  }
}

type ExtendedConfig = typeof config & {
  AUTH_UI_ALIASES?: string[];
  SDK_API_ALIASES?: string[];
  HELPER_BOT_ENABLED?: boolean,
  DEFAULT_LOGIN_PROVIDER?: string;
  LOCAL?: boolean;
  sentry: {
    dsn: string;
    enabled: boolean;
    environment: string;
    errorReplaySessions: number;
    maxBreadcrumbs: number;
    project: string;
    replaySessions: number;
    tracesSampleRate: number;
  };
  stripe?: any;
}

const uiConfig = ((uiConfigModule as any).default || uiConfigModule) as (...args: any[]) => ExtendedConfig;

export default uiConfig(
  config,
  runningProjects,
  localOverrides,
  true,
  undefined,
  (runtimeConfig: ExtendedConfig) => runtimeConfig.AUTH_UI_ALIASES,
) as ExtendedConfig;
